import axios from 'axios'
import moment from 'moment'
import store from '@/store'
//
import { getCookieValue } from '@/utils/cookie'
//
const service = axios.create({
    //  baseURL: process.env.VUE_APP_API_BASE_URL,
    //  timeout: process.env.VUE_APP_API_TIMEOUT,
    withCredentials: true
})

service.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

service.interceptors.request.use(config => {
    config.headers['X-XSRF-TOKEN'] = getCookieValue('XSRF-TOKEN')
    if (config.url.indexOf('/auth/me') >= 0) {
        return config
    }
    config.request_at = new moment().format('Y-MM-DDTHH:mm:ss.SSS')
    store.dispatch('axios/request', config)
    return config
})

service.interceptors.response.use(response => {
    store.dispatch('axios/response', response)
    return response
}, (error) => {
    store.dispatch('axios/response', error)

    let text = null
    if (!error.response) {
        // offline
        text = 'ネットワークが不安定です。接続状況をご確認ください。'
    } else {
//        if (error.config.url.indexOf('/auth/me') >= 0) {
//            throw error
//        }
        text = error.response.data && error.response.data.message ? error.response.data.message : null
        switch (error.response.status) {
            case 403:
                // auth
                break
            case 422:
                // validation
                break
            case 500:
                // system
                break
        }
    }
    store.dispatch('notification/push', { color: 'danger', text: text, })

    throw error
})

export default service

